(function($, window, document, s, undefined){


  // AJAX ADD TO CART

  var initEpubGenerationWatch = function initEpubGenerationWatch() {
    $('.download-ebook-form')
      .on('ajax:success', function ajaxAddToCartResponse(e, data) {
        var cssClass = data.success ? 'success' : 'error';
        var $submitBtn = $(e.target).find('[type="submit"]');

        if (data.html) {
          s.showAndHideNotification(data.html, cssClass);
        }

        if (data.success && data.file_url) {
          $('.download-ebook-form .hidden-download-button')
            .attr('href', data.file_url)
            .attr('download', data.file_name)
            .get(0)
            .click();

          s.statefulButtonChange($submitBtn, 'success');
        } else {
          s.statefulButtonChange($submitBtn, 'error');
        }
      })
      .on('ajax:error', function ajaxAddToCartSuccess(e, data) {
        var cssClass = data.success ? 'success' : 'error';

        s.showAndHideNotification(
          'Δυστυχώς, δεν μπόρεσε να δημιουργηθεί το ebook σας. Ενημερωθήκαμε '+
          'για το συμβάν και θα το ελέγξουμε.', data.cssClass);

        s.statefulButtonChange($(e.target).find('[type="submit"]'), 'error');
      })
      .on('submit', function ajaxAddToCartSubmit(e){
        s.showLoadingSpinner($(e.target).find('[type="submit"]')[0], 'grey');
      });
  };


  var checkForEpubPages = function checkForEpubPages() {
    if (s.bodyId === 'body-account-ebooks') {
      initEpubGenerationWatch();
    }
  };

  s.callOnReady(checkForEpubPages);

})(jQuery, this, this.document, window.s);
